import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Sidebar({ navItems }) {
  const location = useLocation();

  return (
    <nav className="nav-bar">
      <div className="nav-bar-inner">
        {navItems.map(item => {
          const isActive = location.pathname === item.path ||
            (item.path !== '/dashboard' && location.pathname.startsWith(item.path));

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive ? 'nav-item-active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
              {item.badge > 0 && (
                <span className="nav-badge">{item.badge}</span>
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default Sidebar;
